/* eslint-disable @typescript-eslint/no-explicit-any */
// src/redux/payments/invoices/thunk.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  InvoicesListResponse,
  FetchInvoicesPayload,
  DownloadInvoiceResult,
  DownloadInvoicePayload,
} from './types';
import { apiClient } from '@/utils/apiClient';
import { toQS } from '@/utils/toQS';

export const fetchInvoices = createAsyncThunk<
  InvoicesListResponse,
  FetchInvoicesPayload | undefined,
  { rejectValue: string }
>('payments/invoices/fetch', async (payload, { rejectWithValue }) => {
  try {
    const qs = toQS(payload as Record<string, string | number | boolean | null | undefined> | undefined);
    const res = await apiClient(`/payments/api/v1/invoices/${qs}`, {
      method: 'GET',
    });
    return res as InvoicesListResponse;
  } catch (err: any) {
    const r: any = err?.response ?? err;
    const msg =
      (Array.isArray(r?.error) && r.error.join(' ')) ||
      r?.error ||
      r?.message ||
      'Failed to load invoices';
    return rejectWithValue(String(msg));
  }
});

export const downloadInvoiceFile = createAsyncThunk<
  DownloadInvoiceResult,
  DownloadInvoicePayload,
  { rejectValue: string }
>(
  'payments/invoices/downloadFile',
  async ({ invoice_id }, { rejectWithValue }) => {
    if (!invoice_id) return rejectWithValue('invoice_id is required');

    try {
      const response = await apiClient(
        `/payments/api/v1/invoices/${encodeURIComponent(invoice_id)}/download/`,
        {
          method: 'GET',
        }
      );

      const data = response as any;

      if (data?.file_url) {
        return {
          file_url: data.file_url,
          number: data.number,
          created_at: data.created_at,
          id: data.id,
        };
      }

      return rejectWithValue('No file URL found in response');
    } catch (err: any) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        'Failed to download invoice file';
      return rejectWithValue(msg);
    }
  }
);
